/* Visible storefront names only. Product records, URLs, variant data and JSON-LD stay intact. */
(() => {
  if (window.PPProductNames) return;
  const names = '.product-card__title,.horizontal-product__title,.recommend__title,.product__title h1,.product__title h2,.product-sticky-form__variant p.font-medium,.cart-item__name,.cart-item__title,.pp-accessory-title,.pp-option-name,.pp-recommendation-title,[data-pp-product-title],a[href*="/products/"],.breadcrumb [aria-current="page"],.breadcrumbs [aria-current="page"]';
  const contexts = 'product-card,.product-card,.product__title,.cart-item,.horizontal-product,.quick-view,.pp-option-card,.pp-accessory,.pp-recommendation-card,[data-pp-product-title]';
  const skip = 'script,style,noscript,textarea,input,select,option,code,pre,[contenteditable]:not([contenteditable="false"]),[data-pp-product-name-ignore]';
  function clean(text) {
    if (!text || !/potteskjuler\b/i.test(text)) return text;
    let next = text.replace(/\s*(?:\[\s*potteskjuler\s*\]|\(\s*potteskjuler\s*\))/gi,'');
    next = next.replace(/\s+(?:[-–—|:]\s*)?potteskjuler\s*$/i,'');
    // Never erase a standalone category label, and preserve untouched whitespace.
    return next.trim() ? next : text;
  }
  function rewriteText(node) {
    const parent=node.parentElement;
    if (!parent || parent.closest(skip) || !parent.closest(names)) return;
    const before=node.nodeValue;
    let after=clean(before);
    // Concept's animated headings may place each word in its own span.
    const container=parent.closest(names);
    if (/^\s*(?:\[\s*potteskjuler\s*\]|\(\s*potteskjuler\s*\))\s*$/i.test(before) && container.textContent.trim()!==before.trim()) after='';
    if(after!==before)node.nodeValue=after;
  }
  function scan(root) {
    if(root.nodeType===Node.TEXT_NODE){rewriteText(root);return;}
    if(root.nodeType!==Node.ELEMENT_NODE || root.closest(skip))return;
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    while(walker.nextNode())rewriteText(walker.currentNode);
    const attrs=[...(root.matches('[aria-label],[title],img[alt]')?[root]:[]),...root.querySelectorAll('[aria-label],[title],img[alt]')];
    attrs.forEach(node=>{
      if(node.closest(skip) || !(node.closest(contexts) || node.closest('a[href*="/products/"]')))return;
      ['aria-label','title','alt'].forEach(attr=>{
        const before=node.getAttribute(attr);if(!before)return;
        const after=clean(before);if(after!==before)node.setAttribute(attr,after);
      });
    });
  }
  window.PPProductNames={clean,refresh:scan};
  function start() {
    scan(document.body);
    const pending=new Set();
    let frame=0;
    function flush() {
      frame=0;
      const roots=[...pending].filter(node=>node.isConnected);
      pending.clear();
      roots.filter(node=>!roots.some(other=>other!==node && other.contains?.(node))).forEach(scan);
    }
    const observer=new MutationObserver(records=>{
      records.forEach(record=>{
        if(record.type==='childList')record.addedNodes.forEach(n=>pending.add(n));
        else pending.add(record.target);
      });
      if(pending.size && !frame)frame=requestAnimationFrame(flush);
    });
    observer.observe(document.body,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['aria-label','title','alt','href']});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
